import { CreateAdditionalAssignmentBody } from '../app-types/additional-assignment';
import { CreateApiAdditionalAssignmentBody } from '../api-types/additional-assignment.api';
import { formatDateToISOString } from '../../shared/helpers/date.func';

export const transformCreateAdditionalAssignmentToApiCreateAdditionalAssignmentBody = (
	input: CreateAdditionalAssignmentBody,
) => {
	const output: CreateApiAdditionalAssignmentBody = {
		startOfCare: input.startOfCare ? formatDateToISOString(input.startOfCare) : undefined,
		categoryTypeOfCareId: input.categoryTypeOfCareId,
		ownerOfAdditionalAssignmentId: input.ownerOfAdditionalAssignmentId,
		careRelatedHandycapId: input.careRelatedHandycapId,
		documentIds: input.documentIds,
	};
	return output;
};
